module.exports = __webpack_public_path__ + "static/logotype-2164a515da15746d1d53b59b90a15180.svg";